// //Uncomment this code and comment the below code to run it in local

// import axios from 'axios';

// export const API_URL = "http://localhost:5454";
// export const DEPLOYED_URL = "https://zosh-bazzar-backend.onrender.com"
// // change api

// export const api = axios.create({
//   baseURL: API_URL, 
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// Uncomment below code before deployment

import axios from 'axios';

// Use relative path so it works with NGINX reverse proxy
export const API_URL = "/api";

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
